import { Route } from '@angular/router';
import { PermissionModuleGuard } from '@core/auth/guards/permission.guard';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/dashboards/project'
    { path: '', pathMatch: 'full', redirectTo: 'auth' },

    // Auth routes for guests
    {
        path: 'auth',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'sign-in' },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.routes'),
            },
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
        ],
    },

    {
        path: 'main',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'inventory',
            },
            {
                path: 'inventory',
                canActivate: [PermissionModuleGuard],
                data: { code: 'inventory' },
                loadChildren: () =>
                    import('app/modules/main/inventory/inventory.routes'),
            },
            {
                path: 'users',
                canActivate: [PermissionModuleGuard],
                data: { code: 'users' },
                loadChildren: () =>
                    import('app/modules/main/users/users.routes'),
            },
            {
                path: 'settings',
                canActivate: [PermissionModuleGuard],
                data: { code: 'settings' },
                loadChildren: () =>
                    import('app/modules/main/setting/settings.routes'),
            },
        ],
    },
];
